import { render, staticRenderFns } from "./FrmCar.vue?vue&type=template&id=009457d2&scoped=true"
import script from "./FrmCar.vue?vue&type=script&lang=js"
export * from "./FrmCar.vue?vue&type=script&lang=js"
import style0 from "./FrmCar.vue?vue&type=style&index=0&id=009457d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009457d2",
  null
  
)

export default component.exports